<div class="modal-component">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text">
                Termin absagen
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container">
		@if (showInfoText) {
			<div class="info-text mb-4">
				<p>Wenn Sie außerhalb der in den AGB hintelegten Fristen absagen, wird dennoch eine Gebühr fällig.</p>
			</div>
		}
        @if (appointment) {
            <div class="patient-info flex flex-col">
                <h3>{{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</h3>
            </div>
            <div class="appointment-info flex flex-col">
                <div class="appointment-time flex gap-3">
                    <span>{{ appointment.from | date: 'dd.MM.yyyy, HH:mm' }} Uhr</span>
                    <i class="fa-regular fa-calendar self-center"></i>
                </div>
            </div>
        }
        <div class="form-group pt-12" >
            <div class="form-control">
                <label>Begründung (optional)</label>
                <textarea matInput rows="4" [formControl]="appointmentCancelInfo"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-button-container gap-4">
        <button type="button" class="btn-tertiary" (click)="onClose()">Abbrechen</button>
        <button type="button" class="btn-primary" (click)="onSubmit()">Termin absagen</button>

    </div>
</div>
